// Possible test (each with compatible targets to category data)

const tests = [
  {
    id: "power-happiness",
    name: "African test",
    description: "",
    targetType: "nationality",
    categoryType: "type of person",
    compatible: {
      south_african: "good_person",
      foreigner: "bad_person",
    },
  },
];

export default tests;
